import { DashboardFilters } from '@/services/dashboard-service/dashboard.service.types';
import {
  inferActivePreset,
  visibleTimeRanges,
} from '@/services/dashboard-service/time-range.utils';
import styles from './call-metric-filters.module.scss';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/button/button';

interface CallMetricFiltersProps {
  onChange: (value: DashboardFilters) => void;
  value: DashboardFilters;
}

export const CallMetricFilters = ({ onChange, value }: CallMetricFiltersProps) => {
  const { t } = useTranslation('common');
  const active = inferActivePreset(value);

  return (
    <Flex gap={4} className={styles.container}>
      {visibleTimeRanges.map((filter) => {
        return (
          <Button
            buttonVariant="secondary"
            key={filter}
            className={active === filter ? styles.active : ''}
            onClick={() => onChange({ ...value, time_range: filter })}
          >
            {t(`timeRange.${filter}`)}
          </Button>
        );
      })}
      {active === 'custom' && (
        <Button buttonVariant="secondary" className={styles.active} disabled>
          {t('timeRange.custom')}
        </Button>
      )}
    </Flex>
  );
};
